import { render, staticRenderFns } from "./FavoriteDevicetem.vue?vue&type=template&id=0cf82926&scoped=true&"
import script from "./FavoriteDevicetem.vue?vue&type=script&lang=js&"
export * from "./FavoriteDevicetem.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteDevicetem.vue?vue&type=style&index=0&id=0cf82926&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf82926",
  null
  
)

export default component.exports